import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { ArrowChevronRightMiniIcon } from '@calendly/ui/components/icons'
import { Popup, Body, Footer, Header, Title } from '@calendly/ui/components/popup'
import { useState } from 'react'

import {
  Subtext,
  ReasonButton,
  StepIndicator,
  HeaderInner,
  ProgressBarWrapper,
  ProgressBar
} from './styles'

const ReasonOption = ({ onSelect, selected, reason, reasonType }) => (
  <ReasonButton
    onClick={() => onSelect(reason, reasonType)}
    data-selected={selected}
  >
    {reason}
    <ArrowChevronRightMiniIcon />
  </ReasonButton>
)

const ReasonOptions = ({ abuseTypeOptions, onSelect, selectedType }) => (
  <>
    {abuseTypeOptions.map((type) => (
      <ReasonOption
        key={type}
        onSelect={onSelect}
        selected={selectedType === type}
        reason={I18n.t(`publisher.block_invitee.reason_modal.options.${type}`)}
        reasonType={type}
      />
    ))}
  </>
)

export const BlockReasonModal = ({
  onChooseReason,
  onClose,
  inviteeName
}) => {
  const abuseTypes = ['spam', 'harassment', 'scam', 'no_show_or_unwelcome', 'something_else']
  const [selectedReason, setSelectedReason] = useState(null)
  const [selectedType, setSelectedType] = useState(null)

  const handleSelect = (reason, type) => {
    setSelectedReason(reason)
    setSelectedType(type)
  }

  const handleNext = () => {
    if (selectedReason && selectedType) {
      onChooseReason(selectedReason, selectedType)
    }
  }

  return (
    <Popup onClose={onClose}>
      <Header>
        <HeaderInner>
          <ProgressBarWrapper>
            <StepIndicator>Step 1 of 2</StepIndicator>
            <ProgressBar step={1} total={2} />
          </ProgressBarWrapper>
          <Title>
            {I18n.t('publisher.block_invitee.reason_modal.title', { name: inviteeName })}
          </Title>
        </HeaderInner>
      </Header>
      <Body>
        <Subtext>{I18n.t('publisher.block_invitee.reason_modal.subtext')}</Subtext>
        <ReasonOptions
          abuseTypeOptions={abuseTypes}
          onSelect={handleSelect}
          selectedType={selectedType}
        />
      </Body>
      <Footer>
        <Button
          decoration="secondary-outline"
          onClick={onClose}
        >
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button
          decoration="primary"
          onClick={handleNext}
          disabled={!selectedType}
        >
          {I18n.t('publisher.action.next')}
        </Button>
      </Footer>
    </Popup>
  )
}
